<template>
	<div id="app">
		<index />
	</div>
</template>

<script>
// import Index from './components/index.vue'      // 花叻啥官网
// import Index from './components/yeshu.vue'     // 耶数官网
import Index from "./components/cyxy.vue"; // 创羽新研
//import Index from './components/guha.vue'     // 谷哈

export default {
	name: "app",
	components: {
		Index,
	},
	data() {
		console.log(Index);
		if(false){
			return {
				msg: "Welcome to Your Vue.js App",
			};

		}
		if(true){
			return {
				title: "创羽新研",
				keyword: "花叻啥，家庭记账，生活记账，记账管家，理财助手，账本共享，专业统计",
				description: "花叻啥是一款家庭及个人生活记账软件，成员之间能共享账本记录，通过图表从多维度了解家庭和个人消费情况，帮助您及您的家庭合理控制消费预算支出",

			};
		}
		
	}
};
</script>

<style>
body {
	margin: 0;
}

#app {
	font-family: "Avenir", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	/* text-align: center; */
	color: #2c3e50;
	/* margin-top: 60px; */
}
</style>
